<template>
  <el-container class="app-shell">
    <el-aside class="shell-sidebar" width="280px" role="complementary">
      <slot name="sidebar" />
    </el-aside>
    <el-container class="shell-main">
      <el-header class="shell-header" height="70px">
        <slot name="header" />
      </el-header>
      <el-main class="shell-content">
        <slot />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default { name: 'AppShell' }
</script>

<style scoped>
.app-shell {
  height: 100vh;
  overflow: hidden;
  background:
    radial-gradient(800px 400px at 20% -10%, rgba(0,56,49,0.06), transparent 60%),
    radial-gradient(600px 320px at 120% 10%, rgba(0,56,49,0.05), transparent 60%),
    var(--bg-page);
}

.shell-sidebar {
  background: linear-gradient(180deg, #003831 0%, #0b584d 100%);
  color: #fff;
  border-right: 1px solid rgba(255,255,255,.08);
  padding: 16px 14px 20px;
  box-shadow: var(--shadow-soft);
  box-sizing: border-box;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

.shell-main {
  min-height: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.shell-header {
  background: linear-gradient(90deg, #003831 0%, #0b6a59 100%);
  color: #fff;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  display: flex;
  padding-top: 75px;
  align-items: center;
  flex: 0 0 auto;
}

.shell-content {
  flex: 1;
  min-height: 0;
  padding: 20px 24px 32px;
  overflow-y: auto;
  background: var(--bg-page);
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .shell-sidebar { width: 220px !important; padding: 12px; }
}

@media (max-width: 720px) {
  .app-shell {
    display: block;
    height: auto;
    overflow: visible;
  }

  .shell-sidebar {
    width: 100% !important;
    position: sticky;
    top: 0;
    z-index: 10;
    height: auto;
  }

  .shell-main {
    height: auto;
    overflow: visible;
  }

  .shell-content {
    overflow: visible;
  }
}
</style>
